export const TABLE_SETUP_COMPONENT = "TableSetup";
export const ADMINISTRATION_COMPONENT = "Administration";

export const GLOBAL_COMPONENT = "Global";

export const TABLE_SETUP_COMPONENT_ADVANCED_OPTIONS_TOGGLE = "Advanced_Options_Toggle";
export const TABLE_SETUP_HIDE_SYSTEM_FIELDS= "Hide_System_Fields";

export const GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT = "Filter_GroupCode_Default";

export const GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT = "Select_Database_Import_Default";
export const GLOBAL_COMPONENT_SELECT_DATABASE_LEGACY_DEFAULT = "Select_Database_Legacy_Default";
export const GLOBAL_COMPONENT_SELECT_DATABASE_VALIDATION_DEFAULT = "Select_Database_Validation_Default";
export const GLOBAL_COMPONENT_SELECT_DATABASE_LOADFILE_DEFAULT = "Select_Database_Loadfile_Default";

export const ADMINISTRATION_COMPONENT_PERMISSION_DEFAULT_GROUPCODE = "Permission_Default_GroupCode";
export const ADMINISTRATION_COMPONENT_PERMISSION_DEFAULT_ENTITY = "Permission_Default_Entity";

export const SELECT_VALUES_DATABASES = "Databases";


export const PREFERENCE_OBJECT_TYPES = [
  "Application",
  "User",
  "UserGroup",
  "Entity",
  "GroupCode"
];